export default "__VITE_ASSET__89bdb309__"